import { Injectable } from '@angular/core';
import { GlobalService } from '../global.service';
import { Observable } from 'rxjs';

@Injectable()
export class RechargesService {

  constructor(private globalService: GlobalService) {}

  getNombre(): Observable<any> {
    return this.globalService.get('/SP-GetNombreRecharges/');
  }

  add(data: any): Observable<any> {
    return this.globalService.post('/SP-AddRecharges/', data);
  }

  export(data: any): Observable<any> {
    return this.globalService.post('/SP-ExportRecharges/', data);
  }

  delete(data: any): Observable<any> {
    return this.globalService.post('/SP-DeleteRecharges/', data);
  }

  import(data: any): Observable<any> {
    return this.globalService.post('/SP-ImportRecharge/', data);
  }
}
